var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ListPageWithCreateButton',{attrs:{"createRoutName":"scoreManager.create","showCreateBtn":_vm.checkUserRole('SND'),"createBtnName":_vm.$t('scoreManager.create')}},[_vm._v(" 3 "),_c('template',{slot:"listDataContent"},[_c('data-table',{attrs:{"csv_url":"score-manager/export","headers_prop":_vm.headers,"list_url_prop":"/score-manager"}})],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }